import { Select } from "chakra-react-select";
export interface SelectOption {
  readonly value: string;
  readonly label: string;
  readonly isFixed?: boolean;
  readonly isDisabled?: boolean;
  readonly [x: string]: any,
}

type Props = {
  [x: string]: any,
};

const CustomReactSelect = ({...rest}: Props) => {
  return (
      <Select {...rest} />
  )
}

export default CustomReactSelect